import { useTranslation } from 'react-i18next';

const SectionServices = () => {
    const { t } = useTranslation();

    const services = [
        {
            number: '01',
            title: t('services.service1.title'),
            description: t('services.service1.description')
        },
        {
            number: '02',
            title: t('services.service2.title'),
            description: t('services.service2.description')
        },
        {
            number: '03',
            title: t('services.service3.title'),
            description: t('services.service3.description')
        },
        {
            number: '04',
            title: t('services.service4.title'),
            description: t('services.service4.description')
        }
    ];

    return (
        <section className='services-section'>
            <div className='services-header text-center'>
                <h2 className='font-bauhaus-medium'>{t('services.title')}</h2>
            </div>
            <div className='services-grid'>
                {services.map((service, index) => (
                    <div key={index} className='service-card'>
                        <div className='service-number'>{service.number}</div>
                        <h3 className='font-tomorrow'>{service.title}</h3>
                        <p className='font-tomorrow'>{service.description}</p>
                    </div>
                ))}
            </div>
            <div className='homesrv-cta text-center'>
                <button className='btn-cta-link' onClick={() => window.location.href='/dich-vu'}>
                    {t('services.cta')} →
                </button>
            </div>
        </section>
    );
}

export default SectionServices;
